import { track } from '@vercel/analytics/react';

/**
 * Custom analytics events for NoMoreAI
 */

export const analyticsEvents = {
  // App lifecycle
  appLoaded: () => {
    track('app_loaded', {
      timestamp: new Date().toISOString()
    });
  },

  // Image analysis
  imageUploaded: (fileSize: number, fileType: string) => {
    track('image_uploaded', {
      file_size: fileSize,
      file_type: fileType,
      timestamp: new Date().toISOString()
    });
  },

  analysisStarted: () => {
    track('analysis_started', {
      timestamp: new Date().toISOString()
    });
  },

  analysisCompleted: (source: string, aiProbability: number, riskScore: number) => {
    track('analysis_completed', {
      source,
      ai_probability: aiProbability,
      risk_score: riskScore,
      timestamp: new Date().toISOString()
    });
  },

  analysisFailed: (error: string) => {
    track('analysis_failed', {
      error,
      timestamp: new Date().toISOString()
    });
  },

  // Feedback
  feedbackFormOpened: () => {
    track('feedback_form_opened', {
      timestamp: new Date().toISOString()
    });
  },

  feedbackSubmitted: (hasName: boolean, hasEmail: boolean) => {
    track('feedback_submitted', {
      has_name: hasName,
      has_email: hasEmail,
      timestamp: new Date().toISOString()
    });
  },

  feedbackFailed: () => {
    track('feedback_failed', {
      timestamp: new Date().toISOString()
    });
  },

  // Admin panel
  adminPanelAccessed: () => {
    track('admin_panel_accessed', {
      timestamp: new Date().toISOString()
    });
  },

  adminLoginSuccess: () => {
    track('admin_login_success', {
      timestamp: new Date().toISOString()
    });
  },

  adminLoginFailed: () => {
    track('admin_login_failed', {
      timestamp: new Date().toISOString()
    });
  }
};
